export const VERIFY_PAN = 'VERIFY_PAN';
export const VERIFY_PAN_SUCCESS = 'VERIFY_PAN_SUCCESS';

export const SEND_OTP = 'SEND_OTP';
export const SEND_OTP_SUCCESS = 'SEND_OTP_SUCCESS';

export const VERIFY_OTP = 'VERIFY_OTP';
export const VERIF_OTP_SUCCESS = 'VERIF_OTP_SUCCESS';

export const GET_DETAILS_SUCCESS = 'GET_DETAILS_SUCCESS';
export const GET_DETAILS = 'GET_DETAILS';

export const GET_PAYMENT_DETAILS_SUCCESS = 'GET_PAYMENT_DETAILS_SUCCESS';
export const GET_PAYMENT_DETAILS = 'GET_PAYMENT_DETAILS';

export const GET_PAYMENT_OTP_SUCCESS = "GET_PAYMENT_OTP_SUCCESS";
export const GET_PAYMENT_OTP = 'GET_PAYMENT_OTP';

export const GET_OTP_SUCCESS = 'GET_OTP_SUCCESS';
export const GET_OTP = 'GET_OTP';

export const VERIFY_OTP_INVESTOR_SUCCESS = 'VERIFY_OTP_INVESTOR_SUCCESS';
export const VERIFY_OTP_INVESTOR = 'VERIFY_OTP_INVESTOR';

export const VERIFY_OTP_PAYMENT_SUCCESS = "VERIFY_OTP_PAYMENT_SUCCESS";
export const VERIFY_OTP_PAYMENT = "VERIFY_OTP_PAYMENT";

export const GEN_INV_TOKENCOMPANY_SUCCESS = 'GEN_INV_TOKENCOMPANY_SUCCESS';
export const GEN_INV_TOKENCOMPANY = 'GEN_INV_TOKENCOMPANY';

export const GET_APPLICATION_WITH_REF_ID_SUCCESS = 'GET_APPLICATION_WITH_REF_ID_SUCCESS';
export const GET_APPLICATION_WITH_REF_ID = 'GET_APPLICATION_WITH_REF_ID';

export const ESIGN_DOCUMENT_SUCCESS = 'ESIGN_DOCUMENT_SUCCESS';
export const ESIGN_DOCUMENT = 'ESIGN_DOCUMENT';

export const GET_Investment_Details_Aplication_Ref_SUCCESS =
  'GET_Investment_Details_Aplication_Ref_SUCCESS';
export const GET_Investment_Details_Aplication_Ref = 'GET_Investment_Details_Aplication_Ref';

export const GET_RM_LIST_SUCCESS = 'GET_RM_LIST_SUCCESS';
export const GET_RM_LIST = 'GET_RM_LIST';

export const GET_CASH_HISTORY = "GET_CASH_HISTORY";
export const GET_CASH_HISTORY_SUCCESS = "GET_CASH_HISTORY_SUCCESS";

export const GET_RM_DASHBOARD_METRICS_SUCCESS = 'GET_RM_DASHBOARD_METRICS_SUCCESS';
export const GET_RM_DASHBOARD_METRICS = 'GET_RM_DASHBOARD_METRICS';

export const GET_EXPORT_AUM_SUCCESS = 'GET_EXPORT_AUM_SUCCESS';
export const GET_EXPORT_AUM = 'GET_EXPORT_AUM';

export const GET_RM_REDIRECTION_LINK_SUCCESS = 'GET_RM_REDIRECTION_LINK_SUCCESS';
export const GET_RM_REDIRECTION_LINK = 'GET_RM_REDIRECTION_LINK';

export const GET_ASSET_CLASSES = 'GET_ASSET_CLASSES';
export const GET_ASSET_CLASSES_SUCCESS = 'GET_ASSET_CLASSES_SUCCESS';
export const GET_ASSET_CLASSES_FAILED = 'GET_ASSET_CLASSES_FAILED';
export const GET_SUB_ASSET_CLASSES = 'GET_SUB_ASSET_CLASSES';
export const GET_SUB_ASSET_CLASSES_SUCCESS = 'GET_SUB_ASSET_CLASSES_SUCCESS';
export const GET_SUB_ASSET_CLASSES_FAILED = 'GET_SUB_ASSET_CLASSES_FAILED';
export const GET_SCHEME_LIST = 'GET_SCHEME_LIST';
export const GET_SCHEME_LIST_SUCCESS = 'GET_SCHEME_LIST_SUCCESS';
export const GET_SCHEME_LIST_FAILED = 'GET_SCHEME_LIST_FAILED';
export const GET_SCHEME_DETAILS = 'GET_SCHEME_DETAILS';
export const GET_SCHEME_DETAILS_SUCCESS = 'GET_SCHEME_DETAILS_SUCCESS';
export const GET_SCHEME_DETAILS_FAILED = 'GET_SCHEME_DETAILS_FAILED';
export const GET_CATEGORY_AVERAGE = 'GET_CATEGORY_AVERAGE';
export const GET_CATEGORY_AVERAGE_SUCCESS = 'GET_CATEGORY_AVERAGE_SUCCESS';
export const GET_CATEGORY_AVERAGE_FAILED = 'GET_CATEGORY_AVERAGE_FAILED';
export const GET_SCHEME_NAV = 'GET_SCHEME_NAV';
export const GET_SCHEME_NAV_SUCCESS = 'GET_SCHEME_NAV_SUCCESS';
export const GET_SCHEME_NAV_FAILED = 'GET_SCHEME_NAV_FAILED';
export const POST_RECOMMENDED_SCHEMES = 'POST_RECOMMENDED_SCHEMES';
export const POST_RECOMMENDED_SCHEMES_SUCCESS = 'POST_RECOMMENDED_SCHEMES_SUCCESS';
export const POST_RECOMMENDED_SCHEMES_FAILED = 'POST_RECOMMENDED_SCHEMES_FAILED';
export const DELETE_RECOMMENDED_SCHEMES = 'DLETE_RECOMMENDED_SCHEMES';
export const DELETE_RECOMMENDED_SCHEMES_SUCCESS = 'DELETE_RECOMMENDED_SCHEMES_SUCCESS';
export const DELETE_RECOMMENDED_SCHEMES_FAILED = 'DELETE_RECOMMENDED_SCHEMES_FAILED';
export const GET_RECOMMENDATION_VALIDATION = 'GET_RECOMMENDATION_VALIDATION';
export const GET_RECOMMENDATION_VALIDATION_SUCCESS = 'GET_RECOMMENDATION_VALIDATION_SUCCESS';
export const GET_RECOMMENDATION_VALIDATION_FAILED = 'GET_RECOMMENDATION_VALIDATION_FAILED';
export const GET_RECOMMENDED_SCHEMES = 'GET_RECOMMENDED_SCHEMES';
export const GET_RECOMMENDED_SCHEMES_SUCCESS = 'GET_RECOMMENDED_SCHEMES_SUCCESS';
export const GET_RECOMMENDED_SCHEMES_FAILED = 'GET_RECOMMENDED_SCHEMES_FAILED';
export const GET_ACCOUNT_TYPE = 'GET_ACCOUNT_TYPE';
export const GET_ACCOUNT_TYPE_SUCCESS = 'GET_ACCOUNT_TYPE_SUCCESS';
export const GET_ACCOUNT_TYPE_FAILED = 'GET_ACCOUNT_TYPE_FAILED';
export const GET_PORTFOLIO_SUCCESS = 'GET_PORTFOLIO_SUCCESS'
export const GET_PORTFOLIO_FAILED = 'GET_PORTFOLIO_FAILED'
export const GET_SWP_SUCCESS = 'GET_SWP_SUCCESS'
export const GET_SWP_FAILED = 'GET_SWP_FAILED'
export const GET_SCHEMES_SUCCESS = 'GET_SCHEMES_SUCCESS'
export const GET_SCHEMES_FAILED = 'GET_SCHEMES_FAILED'

export const GET_ACCOUNT_SUCCESS = 'GET_ACCOUNT_SUCCESS'
export const GET_ACCOUNT_FAILED = 'GET_ACCOUNT_FAILED'


export const GET_DISTRIBUTORS_LIST_SUCCESS = 'GET_DISTRIBUTORS_LIST_SUCCESS';
export const GET_DISTRIBUTORS_LIST = 'GET_DISTRIBUTORS_LIST';

export const ADD_RMS_LIST_SUCCESS = 'ADD_RMS_LIST_SUCCESS';
export const ADD_RMS_LIST = 'ADD_RMS_LIST';

export const ADD_DISTRIBUTOR_SUCCESS = 'ADD_DISTRIBUTOR_SUCCESS';
export const ADD_DISTRIBUTOR = 'ADD_DISTRIBUTOR';

export const GET_SUBDISTRIBUTOR_SUCCESS = 'GET_SUBDISTRIBUTOR_SUCCESS';
export const GET_SUBDISTRIBUTOR = 'GET_SUBDISTRIBUTOR';

export const ENABLE_POA_SUCCESS = 'ENABLE_POA_SUCCESS';
export const ENABLE_POA = 'ENABLE_POA';

export const EDIT_DISTRIBUTOR_SUCCESS = 'EDIT_DISTRIBUTOR_SUCCESS';
export const EDIT_DISTRIBUTOR = 'EDIT_DISTRIBUTOR';

export const EDIT_RM_SUCCESS = 'EDIT_RM_SUCCESS';
export const EDIT_RM = 'EDIT_RM';

export const GET_Countries_SUCCESS = 'GET_Countries_SUCCESS';
export const GET_Countries = 'GET_Countries';

export const APPLICABLE_FOR_POA_SUCCESS = 'APPLICABLE_FOR_POA_SUCCESS';
export const APPLICABLE_FOR_POA = 'APPLICABLE_FOR_POA';

export const GET_TRUSTEE_LIST_SUCCESS = 'GET_TRUSTEE_LIST_SUCCESS';
export const GET_TRUSTEE_LIST = 'GET_TRUSTEE_LIST';

export const ADD_TRUSTEE_SUCCESS = 'ADD_TRUSTEE_SUCCESS';
export const ADD_TRUSTEE = 'ADD_TRUSTEE';

export const UPDATE_TRUSTEE_SUCCESS = 'UPDATE_TRUSTEE_SUCCESS';
export const UPDATE_TRUSTEE = 'UPDATE_TRUSTEE';

export const GET_FUND_MANAGERS_LIST_SUCCESS = 'GET_FUND_MANAGERS_LIST_SUCCESS';
export const GET_FUND_MANAGERS_LIST = 'GET_FUND_MANAGERS_LIST';

export const GET_AIF_APPROVER_LIST_SUCCESS = 'GET_AIF_APPROVER_LIST_SUCCESS';
export const GET_AIF_APPROVER_LIST = 'GET_AIF_APPROVER_LIST';

export const ADD_DISTRIBUTOR_RM_SUCCESS = 'ADD_DISTRIBUTOR_RM_SUCCESS';
export const ADD_DISTRIBUTOR_RM = 'ADD_DISTRIBUTOR_RM';

export const ADD_FUND_MANAGER_SUCCESS = 'ADD_FUND_MANAGER_SUCCESS';
export const ADD_FUND_MANAGER = 'ADD_FUND_MANAGER';

export const GET_AUTHORISEDSIGNATORY_LIST_SUCCESS = 'GET_AUTHORISEDSIGNATORY_LIST_SUCCESS';
export const GET_AUTHORISEDSIGNATORY_LIST = 'GET_AUTHORISEDSIGNATORY_LIST';

export const ADD_AUTHORISEDSIGNATORY_SUCCESS = 'ADD_AUTHORISEDSIGNATORY_SUCCESS';
export const ADD_AUTHORISEDSIGNATORY = 'ADD_AUTHORISEDSIGNATORY';

export const UPDATE_AUTHORISEDSIGNATORY_SUCCESS = 'UPDATE_AUTHORISEDSIGNATORY_SUCCESS';
export const UPDATE_AUTHORISEDSIGNATORY = 'UPDATE_AUTHORISEDSIGNATORY';

export const UPDATE_FUND_MANAGER_SUCCESS = 'UPDATE_FUND_MANAGER_SUCCESS';
export const UPDATE_FUND_MANAGER = 'UPDATE_FUND_MANAGER';

export const UPDATE_DISTRIBUTOR_RM_SUCCESS = 'UPDATE_DISTRIBUTOR_RM_SUCCESS';
export const UPDATE_DISTRIBUTOR_RM = 'UPDATE_DISTRIBUTOR_RM';

export const GET_POAAPPROVER_LIST_SUCCESS = 'GET_POAAPPROVER_LIST_SUCCESS';
export const GET_POAAPPROVER_LIST = 'GET_POAAPPROVER_LIST';

export const ADD_POAAPPROVER_SUCCESS = 'ADD_POAAPPROVER_SUCCESS';
export const ADD_POAAPPROVER = 'ADD_POAAPPROVER';

export const UPDATE_POAAPPROVER_SUCCESS = 'UPDATE_POAAPPROVER_SUCCESS';
export const UPDATE_POAAPPROVER = 'UPDATE_POAAPPROVER';
export const SEND_EMAIL_SUCCESS = 'SEND_EMAIL_SUCCESS';
export const SEND_EMAIL = 'SEND_EMAIL';

export const PHYSICAL_ONBOARDING_SUCCESS = 'PHYSICAL_ONBOARDING_SUCCESS';
export const PHYSICAL_ONBOARDING = 'PHYSICAL_ONBOARDING';

export const ONBOARDING_SUMMARY_REPORT = 'ONBOARDING_SUMMARY_REPORT';
export const ONBOARDING_SUMMARY_REPORT_SUCCESS = 'ONBOARDING_SUMMARY_REPORT_SUCCESS';

export const ONBOARDING_DETAIL_REPORT = 'ONBOARDING_DETAIL_REPORT';
export const ONBOARDING_DETAIL_REPORT_SUCCESS = 'ONBOARDING_DETAIL_REPORT_SUCCESS';

export const DISTRIBUTOR_ONBOARDING_SUMMARY_REPORT_SUCCESS =
  'DISTRIBUTOR_ONBOARDING_SUMMARY_REPORT_SUCCESS';
export const DISTRIBUTOR_ONBOARDING_SUMMARY_REPORT = 'DISTRIBUTOR_ONBOARDING_SUMMARY_REPORT';

export const ONBOARDING_SUMMARY_REPORT_DOWNLOAD_SUCCESS =
  'ONBOARDING_SUMMARY_REPORT_DOWNLOAD_SUCCESS';
export const ONBOARDING_SUMMARY_REPORT_DOWNLOAD = 'ONBOARDING_SUMMARY_REPORT_DOWNLOAD';

export const ONBOARDING_DETAIL_REPORT_DOWNLOAD_SUCCESS =
  'ONBOARDING_DETAIL_REPORT_DOWNLOAD_SUCCESS';
export const ONBOARDING_DETAIL_REPORT_DOWNLOAD = 'ONBOARDING_DETAIL_REPORT_DOWNLOAD';

export const ONBOARDING_DETAIL_REPORT_DOWNLOAD_ALL_SUCCESS =
  'ONBOARDING_DETAIL_REPORT_DOWNLOAD_ALL_SUCCESS';
export const ONBOARDING_DETAIL_REPORT_DOWNLOAD_ALL = 'ONBOARDING_DETAIL_REPORT_DOWNLOAD_ALL';

ONBOARDING_DETAIL_REPORT_DOWNLOAD_ALL_SUCCESS;

export const DISTRIBUTOR_ONBOARDING_SUMMARY_REPORT_DOWNLOAD_SUCCESS =
  'DISTRIBUTOR_ONBOARDING_SUMMARY_REPORT_DOWNLOAD_SUCCESS';
export const DISTRIBUTOR_ONBOARDING_SUMMARY_REPORT_DOWNLOAD =
  'DISTRIBUTOR_ONBOARDING_SUMMARY_REPORT_DOWNLOAD';

export const DISTRIBUTOR_COMMITMENT_AMOUNT_REPORT_SUCCESS =
  'DISTRIBUTOR_COMMITMENT_AMOUNT_REPORT_SUCCESS';
export const DISTRIBUTOR_COMMITMENT_AMOUNT_REPORT = 'DISTRIBUTOR_COMMITMENT_AMOUNT_REPORT';

export const DISTRIBUTOR_COMMITMENT_AMOUNT_REPORT_DOWNLOAD_SUCCESS =
  'DISTRIBUTOR_COMMITMENT_AMOUNT_REPORT_DOWNLOAD_SUCCESS';
export const DISTRIBUTOR_COMMITMENT_AMOUNT_REPORT_DOWNLOAD =
  'DISTRIBUTOR_COMMITMENT_AMOUNT_REPORT_DOWNLOAD';

export const ACKNOWLEDGE_AML_CHECK_SUCCESS = 'ACKNOWLEDGE_AML_CHECK_SUCCESS';
export const ACKNOWLEDGE_AML_CHECK = 'ACKNOWLEDGE_AML_CHECK';

export const GET_AIFAPPROVERACCESS_SUCCESS = 'GET_AIFAPPROVERACCESS_SUCCESS';
export const GET_AIFAPPROVERACCESS = 'GET_AIFAPPROVERACCESS';

export const GET_RMBYID_SUCCESS = 'GET_RMBYID_SUCCESS';
export const GET_RMBYID = 'GET_RMBYID';

export const GET_RMBYIWAPP_SUCCESS = 'GET_RMBYIWAPP_SUCCESS';
export const GET_RMBYIWAPP = 'GET_RMBYIWAPP';

export const GET_DISTRIBUTORRMBYID_SUCCESS = 'GET_DISTRIBUTORRMBYID_SUCCESS';
export const GET_DISTRIBUTORRMBYID = 'GET_DISTRIBUTORRMBYID_SUCCESS';

export const GET_AUTHORISEDSIGNATORYBYID_SUCCESS = 'GET_AUTHORISEDSIGNATORYBYID_SUCCESS';
export const GET_AUTHORISEDSIGNATORYBYID = 'GET_AUTHORISEDSIGNATORYBYID';

export const GET_POAAPPROVERBYID_SUCCESS = 'GET_POAAPPROVERBYID_SUCCESS';
export const GET_POAAPPROVERBYID = 'GET_POAAPPROVERBYID';

export const GET_TRUSTEEBYID_SUCCESS = 'GET_TRUSTEEBYID_SUCCESS';
export const GET_TRUSTEEBYID = 'GET_TRUSTEEBYID';

export const GET_AIF_APPROVERBYID_SUCCESS = 'GET_AIF_APPROVERBYID_SUCCESS';
export const GET_AIF_APPROVERBYID = 'GET_AIF_APPROVERBYID';

export const GET_FUND_MANAGERSBYID_SUCCESS = 'GET_FUND_MANAGERSBYID_SUCCESS';
export const GET_FUND_MANAGERSBYID = 'GET_FUND_MANAGERSBYID';

export const GET_DISTRIBUTORSOFRM_BY_RMID_SUCCESS = 'GET_DISTRIBUTORSOFRM_BY_RMID_SUCCESS';
export const GET_DISTRIBUTORSOFRM_BY_RMID = 'GET_DISTRIBUTORSOFRM_BY_RMID';

export const GET_TRUSTEEACCESS_SUCCESS = 'GET_TRUSTEEACCESS_SUCCESS';
export const GET_TRUSTEEACCESS = 'GET_TRUSTEEACCESS';

export const GET_IMACCESS_SUCCESS = 'GET_IMACCESS_SUCCESS';
export const GET_IMACCESS = 'GET_IMACCESS';

export const GET_AMCADMINACCESS_SUCCESS = 'GET_AMCADMINACCESS_SUCCESS';
export const GET_AMCADMINACCESS = 'GET_AMCADMINACCESS';

export const GET_AMCADMIN_LIST_SUCCESS = 'GET_AMCADMIN_LIST_SUCCESS';
export const GET_AMCADMIN_LIST = 'GET_AMCADMIN_LIST';

export const GET_AMCADMINBYID_SUCCESS = 'GET_AMCADMINBYID_SUCCESS';
export const GET_AMCADMINBYID = 'GET_AMCADMINBYID';

export const ADD_AMCADMIN_SUCCESS = 'ADD_AMCADMIN_SUCCESS';
export const ADD_AMCADMIN = 'ADD_AMCADMIN';

export const UPDATE_AMCADMIN_SUCCESS = 'UPDATE_AMCADMIN_SUCCESS';
export const UPDATE_AMCADMIN = 'UPDATE_AMCADMIN';

export const SEND_CONSENTEMAIL_SUCCESS = 'SEND_CONSENTEMAIL_SUCCESS';
export const SEND_CONSENTEMAIL = 'SEND_CONSENTEMAIL';

export const SEND_CONSENTEMAIL_APPROVE_SUCCESS = 'SEND_CONSENTEMAIL_APPROVE_SUCCESS';
export const SEND_CONSENTEMAIL_APPROVE = 'SEND_CONSENTEMAIL_APPROVE';

export const SEND_CONSENTEMAIL_REJECT_SUCCESS = 'SEND_CONSENTEMAIL_REJECT_SUCCESS';
export const SEND_CONSENTEMAIL_REJECT = 'SEND_CONSENTEMAIL_REJECT';

export const DISTRIBUTOR_COMPLETED_APPLICATIONS_REPORT_SUCCESS =
  'DISTRIBUTOR_COMPLETED_APPLICATIONS_REPORT_SUCCESS';
export const DISTRIBUTOR_COMPLETED_APPLICATIONS_REPORT =
  'DISTRIBUTOR_COMPLETED_APPLICATIONS_REPORT';

export const ONBOARDING_COMPLETED_REPORT_DOWNLOAD_SUCCESS =
  'ONBOARDING_COMPLETED_REPORT_DOWNLOAD_SUCCESS';
export const ONBOARDING_COMPLETED_REPORT_DOWNLOAD = 'ONBOARDING_COMPLETED_REPORT_DOWNLOAD';

export const GET_APPLICATION_DOWNLOAD_SUCCESS = 'GET_APPLICATION_DOWNLOAD_SUCCESS';
export const GET_APPLICATION_DOWNLOAD = 'GET_APPLICATION_DOWNLOAD';

export const SEND_BSE_CONSENT_SUCCESS = 'SEND_BSE_CONSENT_SUCCESS';
export const SEND_BSE_CONSENT = 'SEND_BSE_CONSENT';

// for Id
export const SET_IWAPP_RMID = 'SET_IWAPP_RMID';
export const SET_INVESTOR_CLIENTID = 'SET_INVESTOR_CLIENTID';
export const SET_APPLICANT_ID = 'SET_APPLICANT_ID';
export const SET_APPLICATION_TYPE = 'SET_APPLICATION_TYPE';

export const SET_INTERFACE_CODE = 'SET_INTERFACE_CODE';
export const SET_APPLICATION_ID = 'SET_APPLICATION_ID';

export const GET_RM_HIERARCHY_SUCCESS = 'GET_RM_HIERARCHY_SUCCESS'
export const GET_RM_HIERARCHY = 'GET_RM_HIERARCHY'

export const GET_REPORTS_INVESTOR_LIST_SUCCESS = 'GET_REPORTS_INVESTOR_LIST_SUCCESS'
export const GET_REPORTS_INVESTOR_LIST = 'GET_REPORTS_INVESTOR_LIST'

export const GET_REPORTS_ANALYST_INVESTOR_LIST_SUCCESS = "GET_REPORTS_ANALYST_INVESTOR_LIST_SUCCESS"
export const GET_REPORTS_ANALYST_INVESTOR_LIST = "GET_REPORTS_ANALYST_INVESTOR_LIST"

export const GET_REPORTS_DETAILED_HOLDINGS_SUCCESS = "GET_REPORTS_DETAILED_HOLDINGS_SUCCESS"
export const GET_REPORTS_DETAILED_HOLDINGS = "GET_REPORTS_DETAILED_HOLDINGS"

export const GET_REPORTS_TRANSACTION_HISTORY_SUCCESS = "GET_REPORTS_TRANSACTION_HISTORY_SUCCESS"
export const GET_REPORTS_TRANSACTION_HISTORY = "GET_REPORTS_TRANSACTION_HISTORY"

export const GET_MF_TRANSACTION_WISE_REPORT_SUCCESS = "GET_MF_TRANSACTION_WISE_REPORT_SUCCESS"
export const GET_MF_TRANSACTION_WISE_REPORT = "GET_MF_TRANSACTION_WISE_REPORT"

export const GET_CLIENT_STATEMENT_SUCCESS = "GET_CLIENT_STATEMENT_SUCCESS"
export const GET_CLIENT_STATEMENT = "GET_CLIENT_STATEMENT"

export const REN_GET_CLIENT_STATEMENT_SUCCESS = "GET_CLIENT_STATEMENT_SUCCESS"
export const REN_GET_CLIENT_STATEMENT = "GET_CLIENT_STATEMENT"

export const HOLDING_REPORT_SUCCESS = "HOLDING_REPORT_SUCCESS"
export const HOLDING_REPORT = "HOLDING_REPORT"

export const CAPITAL_GAIN_STATEMENT_SUCCESS = "CAPITAL_GAIN_STATEMENT_SUCCESS"
export const CAPITAL_GAIN_STATEMENT = "CAPITAL_GAIN_STATEMENT"

export const CAPITAL_GAIN_STATEMENT_INVESTOR_SUCCESS = "CAPITAL_GAIN_STATEMENT_INVESTOR_SUCCESS"
export const CAPITAL_GAIN_STATEMENT_INVESTOR = "CAPITAL_GAIN_STATEMENT_INVESTOR"
export const GET_CUSTOMER_TRANSACTION_HISTORY_REPORT_SUCCESS = "GET_CUSTOMER_TRANSACTION_HISTORY_REPORT_SUCCESS"
export const GET_CUSTOMER_TRANSACTION_HISTORY_REPORT = "GET_CUSTOMER_TRANSACTION_HISTORY_REPORT"

export const GET_APPLICATION_TYPES_SUCCESS = 'GET_APPLICATION_TYPES_SUCCESS';
export const GET_APPLICATION_TYPES = 'GET_APPLICATION_TYPES';

export const CREATE_CLIENT_STATEMENT_SUCCESS = "CREATE_CLIENT_STATEMENT_SUCCESS";
export const CREATE_CLIENT_STATEMENT = "CREATE_CLIENT_STATEMENT"

export const GET_CLIENT_STATEMENT_LIST_SUCCESS = "GET_CLIENT_STATEMENT_LIST_SUCCESS"
export const GET_CLIENT_STATEMENT_LIST = "GET_CLIENT_STATEMENT_LIST"

export const UPDATE_CLIENT_STATEMENT_STATUS_SUCCESS = "UPDATE_CLIENT_STATEMENT_STATUS_SUCCESS"
export const UPDATE_CLIENT_STATEMENT_STATUS = "UPDATE_CLIENT_STATEMENT_STATUS"

export const CLIENT_STATEMENT_DOWNLOAD_SUCCESS = "CLIENT_STATEMENT_DOWNLOAD_SUCCESS"
export const CLIENT_STATEMENT_DOWNLOAD = "CLIENT_STATEMENT_DOWNLOAD"

export const SET_FAMILY_DETAILS = "SET_FAMILY_DETAILS"
export const SET_PAN_NUMBER = "SET_PAN_NUMBER"

export const GET_TAGGED_RM_LIST_SUCCESS = "GET_TAGGED_RM_LIST_SUCCESS"
export const GET_TAGGED_RM_LIST = "GET_TAGGED_RM_LIST"

export const SET_IS_PORTFOLIO_AVAILABLE = "SET_IS_PORTFOLIO_AVAILABLE"

export const GET_TAGGED_IA_LIST_SUCCESS = "GET_TAGGED_IA_LIST_SUCCESS"
export const GET_TAGGED_IA_LIST = "GET_TAGGED_IA_LIST"

export const GET_SUB_ROLES_SUCCESS = "GET_SUB_ROLES_SUCCESS"
export const GET_SUB_ROLES = "GET_SUB_ROLES"

export const GET_SUB_ROLE_DETAILS_SUCCESS = "GET_SUB_ROLE_DETAILS_SUCCESS"
export const GET_SUB_ROLE_DETAILS = "GET_SUB_ROLE_DETAILS"

export const GET_FAMILY_LIST_SUCCESS = "GET_FAMILY_LIST_SUCCESS"
export const GET_FAMILY_LIST = "GET_FAMILY_LIST"

export const GET_CORPORATE_ACTION_REPORT_SUCCESS = "GET_CORPORATE_ACTION_REPORT_SUCCESS"
export const GET_CORPORATE_ACTION_REPORT = "GET_CORPORATE_ACTION_REPORT"

export const GET_REPORT_FAMILIES_LIST_SUCCESS = "GET_REPORT_FAMILIES_LIST_SUCCESS"
export const GET_REPORT_FAMILIES_LIST = "GET_REPORT_FAMILIES_LIST"

export const GET_BILLING_ENTITIES_SUCCESS = "GET_BILLING_ENTITIES_SUCCESS"
export const GET_BILLING_ENTITIES = "GET_BILLING_ENTITIES"

export const UPDATE_RIA_FEE_REPORT_STATUS_SUCCESS = "UPDATE_RIA_FEE_REPORT_STATUS_SUCCESS"
export const UPDATE_RIA_FEE_REPORT_STATUS = "UPDATE_RIA_FEE_REPORT_STATUS"

export const GENERATE_RIA_FEE_SUCCESS = "GENERATE_RIA_FEE_SUCCESS"
export const GENERATE_RIA_FEE = "GENERATE_RIA_FEE"

export const UNFREEZE_INVOICE_SUCCESS = "UNFREEZE_INVOICE_SUCCESS"
export const UNFREEZE_INVOICE = "UNFREEZE_INVOICE"

// Action types for the RIA Fee bulk invoice operations. Each operation acts on
// multiple selected billing entities at once (freeze/unfreeze/download/share),
// mirroring the single-record FREEZE_INVOICE / UNFREEZE_INVOICE flow above.
export const BULK_UNFREEZE_INVOICE_SUCCESS = "BULK_UNFREEZE_INVOICE_SUCCESS"
export const BULK_UNFREEZE_INVOICE = "BULK_UNFREEZE_INVOICE"

export const BULK_FREEZE_INVOICE_SUCCESS = "BULK_FREEZE_INVOICE_SUCCESS"
export const BULK_FREEZE_INVOICE = "BULK_FREEZE_INVOICE"

export const BULK_DOWNLOAD_INVOICE_SUCCESS = "BULK_DOWNLOAD_INVOICE_SUCCESS"
export const BULK_DOWNLOAD_INVOICE = "BULK_DOWNLOAD_INVOICE"

export const BULK_SHARE_INVOICE_SUCCESS = "BULK_SHARE_INVOICE_SUCCESS"
export const BULK_SHARE_INVOICE = "BULK_SHARE_INVOICE"

export const GET_FAMILY_INVOICE_INFO_SUCCESS = "GET_FAMILY_INVOICE_INFO_SUCCESS"
export const GET_FAMILY_INVOICE_INFO = "GET_FAMILY_INVOICE_INFO"

export const DOWNLOAD_RIA_FEE_INVOICE_SUCCESS = "DOWNLOAD_RIA_FEE_INVOICE_SUCCESS"
export const DOWNLOAD_RIA_FEE_INVOICE = "DOWNLOAD_RIA_FEE_INVOICE"

export const GET_INVOICE_CONTROL_DASHBOARD_DATA_SUCCESS = "GET_INVOICE_CONTROL_DASHBOARD_DATA_SUCCESS"
export const GET_INVOICE_CONTROL_DASHBOARD_DATA = "GET_INVOICE_CONTROL_DASHBOARD_DATA"

export const GET_REPORT_RM_LIST_SUCCESS = "GET_REPORT_RM_LIST_SUCCESS"
export const GET_REPORT_RM_LIST = "GET_REPORT_RM_LIST"

export const GET_INVOICE_CONTROL_LIST_SUCCESS = "GET_INVOICE_CONTROL_LIST_SUCCESS"
export const GET_INVOICE_CONTROL_LIST = "GET_INVOICE_CONTROL_LIST"

export const FREEZE_INVOICE_SUCCESS = "FREEZE_INVOICE_SUCCESS"
export const FREEZE_INVOICE = "FREEZE_INVOICE"

export const GET_FAMILY_FEE_SUMMARY_SUCCESS = "GET_FAMILY_FEE_SUMMARY_SUCCESS"
export const GET_FAMILY_FEE_SUMMARY = "GET_FAMILY_FEE_SUMMARY"

export const GET_FAMILIES_FOR_RIA_FEE_SETUP_SUCCESS = "GET_FAMILIES_FOR_RIA_FEE_SETUP_SUCCESS"
export const GET_FAMILIES_FOR_RIA_FEE_SETUP = "GET_FAMILIES_FOR_RIA_FEE_SETUP"

export const GET_RIA_FEE_UPDATE_AUDIT_DATA_SUCCESS = "GET_RIA_FEE_UPDATE_AUDIT_DATA_SUCCESS"
export const GET_RIA_FEE_UPDATE_AUDIT_DATA = "GET_RIA_FEE_UPDATE_AUDIT_DATA"

export const GET_FAMILY_MEMBERS_FEE_LIST_DATA_SUCCESS = "GET_FAMILY_MEMBERS_FEE_LIST_DATA_SUCCESS"
export const GET_FAMILY_MEMBERS_FEE_LIST_DATA = "GET_FAMILY_MEMBERS_FEE_LIST_DATA"

export const UPDATE_RIA_FEE_SUCCESS = "UPDATE_RIA_FEE_SUCCESS"
export const UPDATE_RIA_FEE = "UPDATE_RIA_FEE"

export const GET_RIA_FEE_UPDATE_AUDIT_DETAILS_SUCCESS = "GET_RIA_FEE_UPDATE_AUDIT_DETAILS_SUCCESS"
export const GET_RIA_FEE_UPDATE_AUDIT_DETAILS = "GET_RIA_FEE_UPDATE_AUDIT_DETAILS"

export const DOWNLOAD_HOLDINGS_DATA_SUCCESS = "DOWNLOAD_HOLDINGS_DATA_SUCCESS"
export const DOWNLOAD_HOLDINGS_DATA = "DOWNLOAD_HOLDINGS_DATA"

export const GET_EXCLUDED_SECURITIES_SUCCESS = "GET_EXCLUDED_SECURITIES_SUCCESS"
export const GET_EXCLUDED_SECURITIES = "GET_EXCLUDED_SECURITIES"

export const GET_SECURITIES_PREVIEW_SUCCESS = "GET_SECURITIES_PREVIEW_SUCCESS"
export const GET_SECURITIES_PREVIEW = "GET_SECURITIES_PREVIEW"

export const UPDATE_EXCLUDED_SECURITY_LIST_SUCCESS = "UPDATE_EXCLUDED_SECURITY_LIST_SUCCESS"
export const UPDATE_EXCLUDED_SECURITY_LIST = "UPDATE_EXCLUDED_SECURITY_LIST"

export const GET_SECURITY_EXCLUSION_AUDIT_DATA_SUCCESS = "GET_SECURITY_EXCLUSION_AUDIT_DATA_SUCCESS"
export const GET_SECURITY_EXCLUSION_AUDIT_DATA = "GET_SECURITY_EXCLUSION_AUDIT_DATA"

export const GET_SECURITY_EXCLUSION_DETAILS_SUCCESS = "GET_SECURITY_EXCLUSION_DETAILS_SUCCESS"
export const GET_SECURITY_EXCLUSION_DETAILS = "GET_SECURITY_EXCLUSION_DETAILS"

export const MFU_KYC_ONBOARDING_SUCCESS = "MFU_KYC_ONBOARDING_SUCCESS"
export const MFU_KYC_ONBOARDING = "MFU_KYC_ONBOARDING"

export const GET_DATA_FOR_KYC_MODIFICATION_SUCCESS = "GET_DATA_FOR_KYC_MODIFICATION_SUCCESS"
export const GET_DATA_FOR_KYC_MODIFICATION = "GET_DATA_FOR_KYC_MODIFICATION"

export const MFU_KYC_MODIFICATION_SUCCESS = "MFU_KYC_MODIFICATION_SUCCESS"
export const MFU_KYC_MODIFICATION = "MFU_KYC_MODIFICATION"

export const GET_MFU_KYC_STATUS_LIST_SUCCESS = "GET_MFU_KYC_STATUS_LIST_SUCCESS"
export const GET_MFU_KYC_STATUS_LIST = "GET_MFU_KYC_STATUS_LIST"

export const GET_FAMILY_MEMBERS_SUCCESS = "GET_FAMILY_MEMBERS_SUCCESS"
export const GET_FAMILY_MEMBERS = "GET_FAMILY_MEMBERS"

export interface CreateClientStatementRequestBody {
  clientCode: string;
  rmId: string;
  // startDate: string;
  endDate: string;
  accountType: string;
  consolidatedLevel?: string;
  custFilterValue?: string;
  heldAway: string;
}

export interface CreateClientStatementResponseBody {
  isSuccess: boolean;
  message: string;
  jobId: string;
}

export interface GetClientStatementListRequestBody {
  rmId: string;
  sort: string;
  order: string;
  currentPage: number;
  rowsPerPage: number;
  clientCode?: string;
}

export interface ClientStatementReportsList {
  id: string;
  clientCode: string;
  jobId: string;
  status: string;
  rmId: string;
  portfolioId: string | null;
  clientName: string;
  remarks: string | null;
  createdAt: string;
  updatedAt: string;
  reportDate: string;
  accountType: string;
  consolidatedLevel: string;
  custFilterValue: string;
  investorType: string;
  isFamilyHead: string;
}

export interface GetClientStatementListResponseBody {
  reports: Array<ClientStatementReportsList>;
  count: number;
}

export interface UpdateClientStatementStatusRequestBody {
  rmId: string;
  clientCode?: string;
  sort: string;
  order: string;
  currentPage: number;
  rowsPerPage: number;
  updatePendingReports: boolean;
}

export interface UpdateClientStatementStatusResponseBody {
  reports: Array<ClientStatementReportsList>;
  count: number;
}

export interface ClientStatementDownloadRequestBody {
  jobId: string;
}

export interface GetReportFamiliesListRequestBody {
  rmId: any;
  searchInput: string;
}

export interface FamilyObj {
  family_id: string;
  family_name: string;
}

export interface GetReportFamiliesListResponseBody {
  isSuccess: boolean;
  families: Array<FamilyObj>,
  message: string;
  body: string;
}

export interface GetBillingEntitiesRequestBody {
  familyId: any;
  year: number;
  quarter: string;
}

export interface BillingDependentObj {
  dependent_id: string;
  dependent_name: string;
}

export interface EntityObj {
  billing_entity_id: string;
  billing_entity_name: string;
  billing_type: string;
  billing_dependents: Array<BillingDependentObj>
}

export interface GetBillingEntitiesResponseBody {
  isSuccess: boolean;
  family_id: string;
  family_name: string;
  family_head: string;
  entityList: Array<EntityObj>;
  message: string;
  body: string;
  independentEntityList: Array<EntityObj>;
}

export interface UpdateRiaFeeReportStatusRequestBody {
  rmId: string;
  sort: string;
  order: string;
  rowsPerPage: number;
  currentPage: number;
}

export interface RiaFeeReportStatusObj {
  id: number;
  familyName: string;
  billingEntityName: string;
  jobId: string;
  initiatedAt: string;
  rmId: string;
  status: string;
  remarks: string;
  period: string;
  investorType: string;
  billingEntityId: string;
  completedAt: string;
  reportUrl: string;
  startDate: string;
  endDate: string;
  familyId: string;
  createdAt: string;
  updatedAt: string;
  year: number;
  quarter: string;
  investorEmail: string;
  rmEmail: string;
  rmName: string;
  invoiceStatus: string;
  hofName: string;
}

export interface UpdateRiaFeeReportStatusResponseBody {
  reports: Array<RiaFeeReportStatusObj>;
  count: number;
}

// Reshaped to support generating reports for one or many entities in a single
// request. The previous single-value fields (familyId / billingEntityId / rmId,
// all typed `any`) are now typed id arrays (familyIds / billingEntityIds / rmIds)
// that are `null` when the corresponding filter is not applied ("all"). The
// *Name fields are now optional since the backend derives names from the ids.
export interface GenerateRiaFeeRequestBody {
  familyIds: string[] | null;
  year: number;
  quarter: string;
  billingEntityIds: string[] | null;
  rmIds: string[] | null;
  familyName?: string;
  billingEntityName?: string | null;
  investorType:string;
  invoiceState: string | null;
  familyHead: string[] | string;
  loggedinUser: string;
  rmName?: string;
}

export interface GenerateRiaFeeResponseBody {
  isSuccess: boolean;
  message: string;
  body: string;
}

export interface UnfreezeInvoiceRequestBody {
  familyId: any;
  year: number;
  quarter: string;
  billingEntityId: any;
  rmId: string;
  jobId?: number;
}

export interface UnfreezeInvoiceResponseBody {
  isSuccess: boolean;
  message: string;
  body: string;
}

// Request/response bodies for the RIA Fee bulk invoice operations.
// All request bodies share the same filter-based shape: year/quarter identify
// the billing period, while familyIds / rmIds / billingEntityIds scope the set
// of records to act on (each `null` when its filter is not applied), and
// invoiceState optionally narrows by status.
export interface BulkUnfreezeInvoiceRequestBody {
  year: number;
  quarter: string;
  familyIds: Array<string> | null;
  loggedinUser: string;
  rmIds: Array<string> | null;
  invoiceState: string | null;
  billingEntityIds: Array<string> | null;
}

export interface BulkUnfreezeInvoiceResponseBody {
  isSuccess: boolean;
  message: string;
  body: string;
}

export interface BulkFreezeInvoiceRequestBody {
  year: number;
  quarter: string;
  familyIds: Array<string> | null;
  loggedinUser: string;
  rmIds: Array<string> | null;
  invoiceState: string | null;
  billingEntityIds: Array<string> | null;
}

export interface BulkFreezeInvoiceResponseBody {
  isSuccess: boolean;
  message: string;
  body: string;
}

export interface BulkDownloadInvoiceRequestBody {
  year: number;
  quarter: string;
  familyIds: Array<string> | null;
  rmIds: Array<string> | null;
  invoiceState: string | null;
  billingEntityIds: Array<string> | null;
}

export interface BulkDownloadInvoiceResponseBody {
  isSuccess: boolean;
  message: string;
}

export interface BulkShareInvoiceRequestBody {
  year: number;
  quarter: string;
  familyIds: Array<string> | null;
  rmIds: Array<string> | null;
  invoiceState: string | null;
  billingEntityIds: Array<string> | null;
}

export interface BulkShareInvoiceResponseBody {
  isSuccess: boolean;
  message: string;
  body: string;
}

export interface GetFamilyInvoiceInfoRequestBody {
  familyId: string;
  year: number;
  quarter: string;
  billingEntityId: string;
  investorEmail: string;
  rmEmail: string;
  id: number;
}

export interface GetFamilyInvoiceInfoResponseBody {
  isSuccess: boolean;
  message: string;
  body: string;
}

export interface DownloadRiaFeeInvoiceRequestBody {
  familyId: string;
  year: number;
  quarter: string;
  billingEntityId: string;
  investorEmail: string;
  rmEmail: string;
  id: number
}

export interface GetInvoiceControlDashboardDataRequestBody {
  year: number;
  quarter: string;
}

// Invoice status distribution returned by the invoice control dashboard API.
// Each status carries a raw count and its percentage of the total.
// notGenerated / nonBillable / others were added to extend the chart beyond
// the original freeze/unFreeze breakdown.
export interface FreezeStatusDistribution {
  total: number;
  freeze: {
    count: number;
    percentage: number;
  },
  unFreeze: {
    count: number;
    percentage: number;
  },
  notGenerated:{
    count: number;
    percentage: number;
  },
  nonBillable: {
    count: number;
    percentage: number;
  },
  others: {
    count: number;
    percentage: number;
  }
}

export interface RmWiseFreezeDistributionObj {
  rmName: string;
  count: number;
  percentage: number;
  totalEntities: number;
}

export interface InvoiceControlSummaryData {
  rms: number;
  families: number;
  entities: number;
  invoiceShares: number;
  invoiceDownloads: number;
}

export interface GetInvoiceControlDashboardDataResponseBody {
  isSuccess: boolean;
  freezeStatusDistribution: FreezeStatusDistribution;
  rmWiseFreszeDistribution: Array<RmWiseFreezeDistributionObj>;
  invoiceControlSummaryData: InvoiceControlSummaryData;
  message: string;
}

export interface GetReportRmListRequestBody {
  searchInput: string;
}

export interface ReportRmObj {
  iwappRmId: string;
  name: string;
}

export interface GetReportRmListResponseBody {
  rms: Array<ReportRmObj>
}

export interface GetInvoiceControlListRequestBody {
  familyIds: any;
  year: number;
  quarter: string;
  rmIds: any;
  invoiceState: string | null;
}

export interface InvoiceControlListObj {
  rm_name: string;
  family_id: string;
  family_name: string;
  billing_entity_id: string;
  billing_entity_name: string;
  is_dependent: string;
  type: string;
  invoice_state: string;
  family_head: string;
  rm_id: string;
  invoiceEmail: string;
  invoiceDownload: string;
  checked?: boolean;
}

export interface GetInvoiceControlListResponseBody {
  isSuccess: boolean;
  message: string;
  rows: number;
  data: Array<InvoiceControlListObj>;
}

export interface FreezeInvoiceRequestBody {
  familyId: any;
  year: number;
  quarter: string;
  billingEntityId: any;
  rmId: string;
  jobId?: number;
}

export interface FreezeInvoiceResponseBody {
  isSuccess: boolean;
  message: string;
  body: string;
}

export interface GetFamilyFeeSummaryRequestBody {
  year: number;
  quarter: string;
  familyId: string | null;
  currentPage: number;
  rowsPerPage: number;
}

export interface FamilyFeeBreakdownObj {
  portfolio: string;
  portfolioName: string;
  customer: string;
  customerName: string;
  investorType: string;
  isFamilyHead: string;
  feeType: string;
  feeValue: number | null;
}

export interface FamilyFeeSummaryObj {
  familyId: string;
  familyName: string;
  feeType: string;
  feeValue: number | null;
  familyFeeBreakdown: Array<FamilyFeeBreakdownObj>
}

export interface GetFamilyFeeSummaryResponseBody {
  isSuccess: boolean;
  count: number;
  data: { familyFeeSummary: Array<FamilyFeeSummaryObj> }
  message: string;
  body: string;
}

export interface GetFamiliesForRiaFeeSetupRequestBody {
  rmId: string | null;
  searchInput: string;
  currentPage: number;
  rowsPerPage: number;
}

export interface FamilyForRiaFeeSetupObj {
  family_id: string;
  family_name: string;
  hof_code: string;
  hof_name: string;
  rule_type: string;
  rmid: string;
}

export interface GetFamiliesForRiaFeeSetupResponseBody {
  isSuccess: boolean;
  families: Array<FamilyForRiaFeeSetupObj>;
  message: string;
  body: string;
  count: number;
}

export interface GetRiaFeeUpdateAuditDataRequestBody {
  currentPage: number;
  rowsPerPage: number;
  searchInput: string;
  newFeeType: string;
  oldFeeType: string;
}

export interface RiaFeeUpdateAuditDataObj {
  id: number;
  investorName: string;
  hofClientCode: string;
  hofName: string;
  modifiedDate: string;
  newFeeType: string;
  oldFeeType: string;
  clientCode: string;
  portfolioId: string;
  rmId: string | null;
  familyId: string;
  familyName: string;
  oldFixedValue: string | null;
  oldVariableRate: string | null;
  oldSlabs: string | null;
  newFixedValue: string | null;
  newVariableRate: string | null;
  newSlabs: string | null;
  modifiedBy: string;
  isUpdated: string;
  riaFeeUpdatePayload: string;
  riaFeeUpdateResponse: string;
  modifiedById: string;
  year: string | null;
  quarter: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface GetRiaFeeUpdateAuditDataResponseBody {
  data: Array<RiaFeeUpdateAuditDataObj>;
  count: number;
}

export interface GetFamilyMembersFeeListDataRequestBody {
  year: number | null;
  quarter: string | null;
  familyId: string;
}

export interface SlabDataObj {
  slab_min: number;
  slab_max: number;
  rate: number;
}

export interface FamilyMembersFeeListDataObj {
  clientCode: string;
  name: string;
  investorType: string;
  invoiceStatus: string;
  fixed_rate: number | null;
  variable_rate: number | null;
  slabs: Array<SlabDataObj> | null;
  contactNo: string;
  email: string;
  isHof: string;
  status: string;
}

export interface GetFamilyMembersFeeListDataResponseBody {
  isSuccess: boolean;
  data: {
    familyId: string;
    familyName: string;
    feeType: string;
    hofClientCode: string;
    hofName: string;
    members: Array<FamilyMembersFeeListDataObj>;
  };
  message: string;
  body: string;
}

interface SlabsPayloadObj {
  slab_min: number | null;
  slab_max: number | null;
  rate: number | null;
}

interface MemberListPayloadObj {
  portfolio: string;
  clientCode: string;
  name: string;
  investorType: string;
  invoiceStatus: string;
  fixed_rate: number | null;
  variable_rate: number | null;
  slabs: Array<SlabsPayloadObj> | null;
  contactNo: string;
  email: string;
  isModified: string;
}

interface OldMemberListPayloadObj {
  clientCode: string;
  name: string;
  investorType: string;
  invoiceStatus: string;
  fixed_rate: number | null;
  variable_rate: number | null;
  slabs: Array<SlabsPayloadObj> | null;
  contactNo: string;
  email: string;
}

export interface UpdateRiaFeeRequestBody {
  year: number;
  quarter: string;
  familyId: string;
  newFeeType: string;
  oldFeeType: string;
  hofName: string;
  hofClientCode: string;
  familyName: string;
  memberList: Array<MemberListPayloadObj>;
  oldMemberList: Array<OldMemberListPayloadObj>;
}

export interface UpdateRiaFeeResponseBody {
  isSuccess: boolean;
  message: string;
  body: string;
}

export interface AuditDetailsSlabObj {
  slab_min: number | null;
  slab_max: number | null;
  rate: number | null;
}

export interface RiaFeeUpdateAuditDetailsObj {
  id: number;
  investorName: string;
  clientCode: string;
  portfolioId: string;
  rmId: string | null;
  familyId: string;
  familyName: string;
  hofClientCode: string;
  hofName: string;
  oldFeeType: string;
  newFeeType: string;
  oldFixedValue: string | null;
  oldVariableRate: string | null;
  oldSlabs: Array<AuditDetailsSlabObj> | null;
  newFixedValue: string | null;
  newVariableRate: string | null;
  newSlabs: Array<AuditDetailsSlabObj> | null;
  modifiedBy: string;
  modifiedDate: string;
  isUpdated: string;
  riaFeeUpdatePayload: string;
  riaFeeUpdateResponse: string;
  createdAt: string;
  updatedAt: string;
}

export interface GetRiaFeeUpdateAuditDetailsResponseBody {
  data: RiaFeeUpdateAuditDetailsObj
}

export interface DownloadHoldingsDataRequestBody {
  year: number;
  quarter: string;
  portfolioIds: Array<string>;
}

export interface GetExcludedSecuritiesRequestBody {
  year: number;
  quarter: string;
  portfolioIds: Array<string>;
  currentPage: number;
  rowsPerPage: number;
}

export interface ExcludedSecurityObj {
  portfolio: string;
  portfolioName: string;
  security: string;
  securityName: string;
  exclusionReason: string | null;
  isFreezed: string;
  name: string;
  familyId: string;
  familyName: string;
  clientCode: string;
}

export interface GetExcludedSecuritiesResponseBody {
  isSuccess: boolean;
  data: Array<ExcludedSecurityObj>;
  message: string;
  body: string;
  count: number;
}

export interface SecurityPreviewObj {
  name: string;
  familyId: string;
  familyName: string;
  clientCode: string;
  portfolio: string;
  security: string;
  securityName: string;
  isExcluded: string;
  exclusionReason: string;
}

export interface GetSecuritiesPreviewResponseBody {
  data: Array<SecurityPreviewObj>;
  count: number;
}

export interface UpdateExcludedSecurityObj {
  portfolio: string;
  name: string;
  security: string;
  securityName: string;
  isExcluded: string;
  exclusionReason: string;
  familyId: string;
  familyName: string;
  clientCode: string;
}

export interface UpdateExcludedSecurityListRequestBody {
  year: number;
  quarter: string;
  securityList: Array<UpdateExcludedSecurityObj>;
}

export interface UpdateExcludedSecurityListResponseBody {
  isSuccess: boolean;
  message: string;
  body: string;
}

export interface GetSecurityExclusionAuditDataRequestBody {
  year: number;
  quarter: string;
  familyId: string;
  currentPage: number;
  rowsPerPage: number;
  clientCode: string;
  searchInput: string;
}

export interface SecurityExclusionAuditDataObj {
  id: number;
  investorName: string;
  year: string;
  quarter: string;
  clientCode: string;
  portfolioId: string;
  familyId: string;
  familyName: string;
  security: string;
  securityName: string;
  exclusionReason: string;
  isExcluded: string | null;
  modifiedBy: string;
  modifiedDate: string;
  isUpdated: string;
  payload: string;
  response: string;
  modifiedById: string;
  createdAt: string;
  updatedAt: string;
}

export interface GetSecurityExclusionAuditDataResponseBody {
  data: Array<SecurityExclusionAuditDataObj>;
  count: number;
}

export interface SecurityExclusionStateObj {
  isExcluded: string;
  modifiedAt: string;
  modifiedBy: string;
  exclusionReason: string;
}

export interface GetSecurityExclusionDetailsResponseBody {
  familyId: string;
  familyName: string;
  investorName: string;
  securityName: string;
  oldState: SecurityExclusionStateObj;
  newState: SecurityExclusionStateObj;
}

export interface FamilyMemberObj {
  applicationId: number;
  clientCode: string;
  name: string;
  panNo: string;
  email: string;
  mobile: string;
  isHeadOfFamily: string;
  familyName: string;
  accountType: string;
  portfolioList: Array<{
    portfolioId: string;
    portfolioName: string;
  }>
  investorType: string;
}

export interface GetFamilyMembersResponseBody {
  familyMembers: Array<FamilyMemberObj>
}
